module.exports = __webpack_public_path__ + "img/bio-jason-oni.a6cb1f81.png";